/**
 * @param {'snake'|'memory'|'invaders'|'slots'|'poker'|'blackjack'} game
 * @param {Array<{ score: number }>} entries — sorted for display (snake/invaders/slots desc, memory asc)
 * @param {number} score
 */
export function qualifiesForLeaderboard(game, entries, score) {
  const list = Array.isArray(entries) ? entries : [];
  if (list.length < 10) return true;
  if (game === 'snake' || game === 'invaders' || game === 'slots' || game === 'poker' || game === 'blackjack') {
    const lowest = Math.min(...list.map((e) => Number(e.score)));
    return score > lowest;
  }
  if (game === 'memory') {
    const worst = Math.max(...list.map((e) => Number(e.score)));
    return score < worst;
  }
  return false;
}
